<div class="dashboard">
  <div>
    <div>
      <select
        [(ngModel)]="selectedProgramOption"
        class="program-dropdown"
        (change)="onOptionSelect($event)">
        <option value="Events" selected>Events</option>
        <option value="MRPP">MRPP</option>
        <option value="CSI">CSI</option>
      </select>
    </div>
    <p-tabs
      scrollable
      [value]="selectedTab"
      class="engagementDash"
      (valueChange)="onTabChange($event)">
      <p-tablist>
        <p-tab [value]="0">Milestone 1 Payment Schedule</p-tab>
        <p-tab [value]="1">Milestone 2 Payment Schedule</p-tab>
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel [value]="0">
          @if (selectedProgramOption === 'CSI') {
            <app-csi-payment-schedule-milestone1
              [program]="
                programTypesGUID
              "></app-csi-payment-schedule-milestone1>
          }
          @if (isMilestone1Selected && selectedProgramOption !== 'CSI') {
            <app-events-payment-schedule-milestone1
              [selectedProgramOption]="
                selectedProgramOption
              "></app-events-payment-schedule-milestone1>
          }
        </p-tabpanel>
        <p-tabpanel [value]="1">
          @if (selectedProgramOption === 'CSI') {
            <app-csi-payment-schedule-milestone2
              [program]="
                programTypesGUID
              "></app-csi-payment-schedule-milestone2>
          }
          @if (!isMilestone1Selected && selectedProgramOption !== 'CSI') {
            <app-events-payment-schedule-milestone2
              [selectedProgramOption]="
                selectedProgramOption
              "></app-events-payment-schedule-milestone2>
          }
        </p-tabpanel>
      </p-tabpanels>
    </p-tabs>
  </div>
</div>
